import './index.styl';
import template from './index.jst';
import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';
import { Model } from 'backbone';

const tippingChannel = Radio.channel('tipping');

export default class TippingTipsControls extends View {
	get template() {
		return template;
	}

	className() {
		return 'tipping-tip-controls-inner';
	}

	/**
	 * Set all UI for this view
	 * @returns object
	 */
	ui() {
		return {
			autopick: '.js-autopick',
			save: '.js-save'
		};
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	events() {
		return {
			'click @ui.save': 'save',
			'click @ui.autopick': 'autopickTips',
		};
	}

	initialize() {
		this.model = new Model({
			selected_tips_count: 0,
			total_tips_count: 0,
		})
		this.listenTo(tippingChannel, 'saved', this.onSaved);
		this.listenTo(tippingChannel, 'changed', this.onChanged);
		this.listenTo(tippingChannel, 'change:round', this.render);
		this.listenTo(tippingChannel, 'tips:count', this.onReceiveNewData);
		// this.model.getData();
	}

	autopickTips() {
		tippingChannel.trigger('autopick');
	}

	save(){
		tippingChannel.trigger('save');
	}

	onSaved(){
		this.ui.save.text('Saved');
		const selected_tips = this.model.get('selected_tips_count'),
			total_tips = this.model.get('total_tips_count');
		if(selected_tips === total_tips){
			this.ui.save.addClass('disabled');
			
		}
	}

	onChanged(){
		this.ui.save.text('Save');
		this.ui.save.removeClass('disabled');
	}

	onReceiveNewData(args) {
		this.model.set(args);

		return this;
	}
}